import React from "react";
import { Button } from "@mui/material";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

const CompanyDeleteModal = (props) => {
	
	const handleClose = () => {
		props.onConfirm(false)
	};
	
	const handleYes = () => {
		props.onConfirm(true)
	};
	
	const handleNo = () => {
		props.onConfirm(false)
	};
	
	return (
		<Dialog
			open={props.company? true : false}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogTitle id="alert-dialog-title">
				{`Delete Company`}
			</DialogTitle>
			<DialogContent>
				<DialogContentText id="alert-dialog-description">
					Are you sure you want to delete {props.company? props.company.name : ""}?
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleYes}>Yes</Button>
				<Button onClick={handleNo} autoFocus>No</Button>
			</DialogActions>
		</Dialog>
	);
};

export default CompanyDeleteModal;